<template>
    <style-sub-item style="margin-top: 12px;padding:12px" class="c-bi-dashboard-text-style" title="文本样式配置">
        <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
                字体颜色
            </span>
            <el-color-picker v-model="config.color"></el-color-picker>
        </div>
        <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
                字体大小
            </span>
            <el-input-number v-model="config.fontSize" :min="12" :max="60" :step="1" controls-position="right"></el-input-number>
        </div>
        <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
                加粗
            </span>
            <el-switch v-model="config.isBold"></el-switch>
        </div>
        <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
                斜体
            </span>
            <el-switch v-model="config.isItalic"></el-switch>
        </div>
        <slot></slot>
    </style-sub-item>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'

export default {
    name: 'cBiDashboardTextStyle',
    components: {
        styleSubItem
    },
    props: {
        config: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style scoped lang="less">
.c-bi-dashboard-text-style {}
</style>